import { ReactComponent as Arrow } from 'assets/icons/arrow-select.svg';

import styles from './ScrollToTopButton.module.scss';
import { useTranslation } from 'react-i18next';

export const ScrollToTopButton = () => {
	const { t } = useTranslation();
	return (
		<div className={styles.ScrollToTopButton}>
			<button
				className={styles.button}
				onClick={() => {
					window.scrollTo(0, 0);
				}}
			>
				<div className={styles.arrow_wrapper}>
					<Arrow className={styles.arrow} />
				</div>
				<span className={styles.span}>{t(`goUpText`)}</span>
			</button>
		</div>
	);
};
